var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwentythree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f2f60;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n\n      .cls-3 {\n        fill: #ddd;\n      }\n\n      .cls-4 {\n        fill: #fee9aa;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.41,1020.23h399.62c17.66,0,31.97-14.31,31.97-31.97v-5.4c0-17.38-4.72-34.44-13.67-49.35l-9.81-16.35c-15.42-25.7-17.94-57.14-6.81-84.97l2.77-6.93c7.54-18.85,9.76-39.42,6.43-59.45l-4.56-27.38c-4.05-24.33-17.33-46.16-37.06-60.96l-97.14-72.85h-127.88l-101.16,67.44c-26.68,17.79-42.71,47.73-42.71,79.8v268.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M860.89,604.63c8.48,0,16.61-3.37,22.61-9.36l45.21-45.21c6-6,9.36-14.13,9.36-22.61v-50.7c0-17.66-14.31-31.97-31.97-31.97h-34.71c-8.48,0-16.61,3.37-22.61,9.36l-13.24,13.24c-6,6-14.13,9.36-22.61,9.36h-98.65v95.91c0,17.66,14.31,31.97,31.97,31.97h114.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.83,860.38v-351.67c0-8.83,7.16-15.98,15.98-15.98h207.8v367.65h-223.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M362.62,860.38v-367.65h207.8c8.83,0,15.98,7.16,15.98,15.98v351.67h-223.79Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.77,492.73v-111.89c0-8.83,7.16-15.98,15.98-15.98h143.86v127.88h-159.85Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M522.47,492.73v-111.89c0-8.83-7.16-15.98-15.98-15.98h-143.86v127.88h159.85Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.71,236.97h191.82c8.83,0,15.98,7.16,15.98,15.98v111.89h-223.79v-111.89c0-8.83,7.16-15.98,15.98-15.98Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.56,236.97l-31.97-47.95v-31.97c0-8.83-7.16-15.98-15.98-15.98h-31.97c-8.83,0-15.98,7.16-15.98,15.98v31.97l-31.97,47.95h127.88Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M346.63,77.12h31.97v63.94h-31.97v-63.94Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.77,556.67h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.71,556.67h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.77,620.61h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.71,620.61h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.71,684.55h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M426.56,556.67h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M490.5,556.67h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M490.5,620.61h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M426.56,620.61h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M426.56,684.55h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.77,684.55h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M490.5,684.55h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.71,412.81h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M426.56,412.81h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M298.68,284.93h31.97v31.97h-31.97v-31.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M394.59,284.93h31.97v31.97h-31.97v-31.97Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.51,1020.23v-207.8c0-17.66-14.31-31.97-31.97-31.97h-159.85c-17.66,0-31.97,14.31-31.97,31.97v207.8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.66,844.4h31.97v31.97h-31.97v-31.97Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M378.6,844.4h31.97v31.97h-31.97v-31.97Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M314.66,908.34h31.97v31.97h-31.97v-31.97Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M378.6,908.34h31.97v31.97h-31.97v-31.97Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M474.51,1020.23h143.86c8.83,0,15.98-7.16,15.98-15.98v-111.89c0-17.66-14.31-31.97-31.97-31.97h-127.88v159.85Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M250.72,860.38h-127.88c-17.66,0-31.97,14.31-31.97,31.97v111.89c0,8.83,7.16,15.98,15.98,15.98h143.86v-159.85Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.81,924.32h31.97v31.97h-31.97v-31.97Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M538.45,924.32h31.97v31.97h-31.97v-31.97Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M826.18,604.63h-98.65c-8.48,0-16.61-3.37-22.61-9.36l-45.21-45.21c-6-6-9.36-14.13-9.36-22.61v-34.71c0-17.66,14.31-31.97,31.97-31.97h2.74c8.48,0,16.61,3.37,22.61,9.36l61.2,61.2c6,6,14.13,9.36,22.61,9.36h2.74c26.48,0,47.95,21.47,47.95,47.95,0,8.83-7.16,15.98-15.98,15.98h0Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M810.2,796.44h-31.97c-8.83,0-15.98-7.16-15.98-15.98s7.16-15.98,15.98-15.98h63.94v-31.97h-31.97v-31.97h-31.97v31.97c-26.48,0-47.95,21.47-47.95,47.95s21.47,47.95,47.95,47.95h31.97c8.83,0,15.98,7.16,15.98,15.98s-7.16,15.98-15.98,15.98h-63.94v31.97h31.97v31.97h31.97v-31.97c26.48,0,47.95-21.47,47.95-47.95s-21.47-47.95-47.95-47.95Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M666.33,796.44h31.97v31.97h-31.97v-31.97Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M890.12,796.44h31.97v31.97h-31.97v-31.97Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M458.53,236.97h-15.98v95.91h-159.85c-17.66,0-31.97,14.31-31.97,31.97h0s223.79,0,223.79,0v-111.89c0-8.83-7.16-15.98-15.98-15.98h0Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M506.48,364.85h-15.98v95.91h-127.88v31.97h159.85v-111.89c0-8.83-7.16-15.98-15.98-15.98h0Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.51,860.38h31.97v159.85h-31.97v-159.85Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M319.99,205l-21.31,31.97h127.88l-21.31-31.97h-85.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwentythree);
export default __webpack_public_path__ + "static/media/twentythree.be9edfbff425ef95d74245d075ddd9e8.svg";
export { ForwardRef as ReactComponent };